module.exports = flarum.reg.get('core', 'forum/components/LogInModal');